import { EditorState, Modifier } from 'draft-js';

export const setBlockData = (editorState, data) => {
    const newContentState = Modifier.mergeBlockData(editorState.getCurrentContent(), editorState.getSelection(), data);

    return EditorState.push(editorState, newContentState, 'change-block-data');
};
